import '../../../stylesheets/components/nav_drawer.scss';

import React, { Component, useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';

import HomeIcon from '@material-ui/icons/Home';
import SimCardIcon from '@material-ui/icons/SimCard';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import HelpOutlineIcon from '@material-ui/icons/Help';
import NewReleasesOutlinedIcon from '@material-ui/icons/NewReleasesOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import ExploreIcon from '@material-ui/icons/Explore';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import LaunchIcon from '@material-ui/icons/LaunchOutlined';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { triggerHapticFeedback } from '../../hapticFeedback';

function ListItemLink(props) {
  const {
    icon, primary, to, onClick, rightIcon
  } = props;

  // Unable to pass onClick directly to RouterLink/Link for some reason..
  const renderLink = React.useMemo(
    () => React.forwardRef((itemProps, ref) => <RouterLink to={{ pathname: to, state: { origin: 'dashboard' } }} ref={ref} {...itemProps} />),
    [to],
  );

  const onClickWrapped = useCallback(() => {
    if (onClick) {
      triggerHapticFeedback();
      onClick();
    }
  }, [onClick]);

  return (
    <li>
      <ListItem button component={renderLink} onClick={onClickWrapped} classes={{ root: 'navBar_ListItem' }}>
        {icon ? <ListItemIcon className="navBar_ListItemIcon">{icon}</ListItemIcon> : null}
        <ListItemText classes={{ primary: 'navBar_ListItem_Text' }} primary={primary} />
        {rightIcon}
      </ListItem>
    </li>
  );
}

function NewTag() {
  return (
    <span className="navBar_newTag">New</span>
  );
}

class NavDrawer extends Component {
  navContent = () => {
    const { onClose, user } = this.props;
    const { supportedFeatures } = user;

    const onStoreClick = () => {
      onClose();

      // TODO: Have the URL come from a new property on User e.g user.storeLink
      // and allow backend to determine 1) if user gets the link and 2) which store 
      const url = 'https://shop.shieldgps.co';

      if (window.cordova) {
        cordova.InAppBrowser.open(url, '_system');
      } else {
        window.open(url, '_system');
      }
    };

    return (
      <div className="navBar">
        <div className="navBar_header">
          <div className="navBar_header_icon">
            <AccountCircleIcon fontSize="large" />
          </div>
          {user.email}
        </div>
        <Divider />
        <List className="navBar_topList">
          <ListItemLink to="/m/devices" primary="Devices" icon={<SimCardIcon fontSize="large" />} onClick={onClose} />

          {supportedFeatures && supportedFeatures.includes('trips_feature')
            ? (<ListItemLink to="/m/trips" primary="Trips"
              icon={<ExploreIcon fontSize="large" />} onClick={onClose} />) : null}

          <ListItemLink to="/m/billing" primary="Billing" icon={<CreditCardIcon fontSize="large" />} onClick={onClose} />

          <ListItemLink to="" primary={<span>Store <NewTag /></span>}
            icon={<LocalGroceryStoreIcon fontSize="large" />}
            rightIcon={<LaunchIcon fontSize='small' color='disabled' />}
            onClick={onStoreClick} />

          <ListItemLink to="/m/help" primary="Help"
            icon={<HelpOutlineIcon fontSize="large" />} onClick={onClose} />

          <ListItemLink to="/m/feature-request" primary="Request a Feature"
            icon={<NewReleasesOutlinedIcon fontSize="large" />} onClick={onClose} />

          <ListItemLink to="/m/settings" primary="Settings"
            icon={<SettingsIcon fontSize="large" />} onClick={onClose} />
        </List>

        <List className="navBar_bottomList">
          <ListItemLink to="/m/logout" primary="Logout" icon={<ExitToAppIcon fontSize="large" />} onClick={onClose} />
          <div className="navBarVersion">
            Version {process.env.VERSION}
          </div>
        </List>
      </div>
    );
  };

  render() {
    const { open, onClose } = this.props;

    return (
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        classes={{
          paper: 'navContent',
        }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        BackdropProps={{
          timeout: 500,
          className: 'navBarModalBackdrop',
        }}
      >
        {this.navContent()}
      </Drawer>
    );
  }
}

NavDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default NavDrawer;
